module.exports = __webpack_public_path__ + "img/loading-morning.431751b2.jpg";